// extracted by mini-css-extract-plugin
export default {"header":"MerchLogo_header__c-LY1","inner":"MerchLogo_inner__3dnWl","link":"MerchLogo_link__TZgHn","linkLabel":"MerchLogo_linkLabel__3RFwz"};